import PlayIcon from './component'

export default PlayIcon
